import React from 'react';
import "./contact.css";

function Contact(props) {
  return (
    <div className="contact-container" id="contact">
      <div className='contact-card'>
        <h2>Contact Me</h2>
        <div className="desc">
          <span className="line"></span>
          Let's connect
        </div>
        <div className='container-card'>
          <div className="card">
            <div className="item">
              <i className="fa-solid fa-location-dot"></i>
              <div className="isi">
                <div className="title">Location</div>
                <div className="value">Jl. Gegerkalong Hilir, Ciwaruga, Kec. Parongpong, Kabupaten Bandung Barat, Jawa Barat 40559</div>
              </div>
            </div>
            <div className="item">
              <i className="fa-regular fa-envelope"></i>
              <div className="isi">
                <div className="title">Email Address</div>
                <a href="mailto:umar.faruq.tif423@polban.ac.id" target="_blank" className="value" rel="noopener noreferrer">umar.faruq.tif423@polban.ac.id
                  <i class="fa-solid fa-up-right-from-square"></i>
                </a>
              </div>
            </div>
            <div className="item">
              <i className="fa-brands fa-whatsapp"></i>
              <div className="isi">
                <div className="title">WhatsApp</div>
                <a href="https://wa.me/62895612950856" target="_blank" className="value" rel="noopener noreferrer">+62895612950856
                  <i class="fa-solid fa-up-right-from-square"></i>
                </a>
              </div>
            </div>
            <div className="items">
              <a href="https://github.com/ufarqrobbany" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-github"></i>
              </a>
              <a href="https://www.instagram.com/u.farq/" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/in/umar-faruq-robbany/" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-linkedin"></i>
              </a>
            </div>
          </div>
          <iframe className="map" title="My Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.1535158273455!2d107.57119757487017!3d-6.872202067239796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e420abc30acf%3A0x10569255865460a5!2sPoliteknik%20Negeri%20Bandung!5e0!3m2!1sen!2sid!4v1709027634155!5m2!1sen!2sid" style={{ border: 0 }} allowFullScreen="" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
}

export default Contact;
